<style lang="scss">
  @use "../../../assets/css/design-system/mixins";
  @use "../../../assets/css/design-system/utils";
  @use "../../../assets/css/design-system/colors";

  .list-group {
    width: 100%;

    .overline {
      width: 100%;
      text-transform: uppercase;
      @include mixins.overline();
      padding: 4px 0 8px 12px;
      color: #63636e; // colors.get(black_50); // TODO - check color with Lucy
    }

    display: flex;
    flex-direction: column;
  }
</style>

<script>
  export let title = "";
</script>

<div class="list-group">
  <div class="overline">{title}</div>
  <slot />
</div>
